import { render, staticRenderFns } from "./promotions-list.vue?vue&type=template&id=8cbe49e8&"
import script from "./promotions-list.vue?vue&type=script&lang=js&"
export * from "./promotions-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports